const state = {
  notice: {},
  notices: []
}

const getters = {
  notice (state) {
    return state.notice
  },
  notices (state) {
    return state.notices
  }
}

const mutations = {
  SET_NOTICE (state, payload) {
    state.notice = payload
  },
  SET_NOTICES (state, payload) {
    state.notices = payload
  },
  DELETE_NOTICE (state, payload) {
    state.notices = state.notices.filter((notice) => {
      return notice.id !== payload
    })
  },
  UPDATE_NOTICE (state, payload) {
    state.notices = state.notices.map((notice) => {
      if (notice.id === payload.id) {
        notice.title = payload.title
        notice.slug = payload.slug
        notice.content = payload.content
        notice.show = payload.show
        notice.image = payload.image
      }
      return notice
    })
  },
  ADD_NOTICE (state, payload) {
    state.notices.push(payload)
  }
}

const actions = {
  DELETE_NOTICE (context, payload) {
    context.commit('DELETE_NOTICE', payload)
  },
  ADD_NOTICE (context, payload) {
    context.commit('ADD_NOTICE', payload)
  },
  UPDATE_NOTICE (context, payload) {
    context.commit('UPDATE_NOTICE', payload)
  },
  SET_NOTICE (context, payload) {
    context.commit('SET_NOTICE', payload)
  },
  SET_NOTICES (context, payload) {
    context.commit('SET_NOTICES', payload)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
